import { networkPlanningIdentification } from '../../DynamicComponent/customize';


/**
   * @description 按照表单数据判断是否机会点是否在所属商圈中
   * @param formData 表单数据对象
   * @param propertyItemMap 所有属性字段的值对象 { 字段的 propertyId: { textValue: 字段的值, id, propertyId, isShow: 是否显示该组件 } }，如
    {
      472: { 'id': 14675, 'propertyId': 472, 'name': '关联显示的输入框', 'textValue': '输入的内容', isShow: true },
      473: { 'id': 14676, 'propertyId': 473, 'name': '测试单选关联', 'textValue': 1891, isShow: true }
    }
   * @return 是否在所属商圈中
   */
export const checkIsInCluster = (
  formData: any,
  propertyItemMap: any
) => {
  if (!formData || !propertyItemMap) {
    return true;
  }

  const itemArray: any[] = [];
  Object.keys(propertyItemMap).forEach(key => {
    itemArray.push(propertyItemMap[key]);
  });
  const networkPlanningItems = itemArray.filter((itm: any) => !!(itm.identification === networkPlanningIdentification));

  if (!networkPlanningItems.length) { // 没有配置网规组件的时候不做校验
    return true;
  }

  const networkPlanningItem = networkPlanningItems[0];
  const { textValue } = networkPlanningItem;
  const _value = JSON.parse(textValue);
  const result = _value ? _value.isInCluster : false;

  return result;
};
